import * as R from 'ramda'

export const isLoggedInSelector = R.path(['auth', 'isLoggedIn'])

export const isLoggingInSelector = R.path(['auth', 'isLoggingIn'])
